import React from 'react';

/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
  BoxC,
  IptC,
  GridC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as GridC from "./_cccGridC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';
import * as hf from './_hf';

export const N = (pz: {
  sPz: ht.dz,
  boxStlz: ht.dz,
  cz: {
    i1zz: ht.dz,
    onChgAsync: () => void,
  }
}) => {

//hf.l(`icvI1zS11Co3f 39: here`);

  return (
    cr.c(BoxC.N, {
      key: 'Iccv23b4b.root',
      boxStlz: {
        ... a('dw/f'),
        ... pz.boxStlz
      },
      oClds: [

        cr.c(GridC.N, {
          key: -30,
          abtType: 'nolineCmnz',
          lineCs: [
            {
              cellCs: [
                {
                  oClds: [
                    cr.c(IptC.S, {
                      key: -10,
                      cz: {
                        bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                        iptType: 'text',
                        vle: pz.cz.i1zz?.i1zrz.i1zra5100s,
                        onChg: ( _s: ht.s ) => {
                          pz.cz.i1zz.i1zrz.i1zra5100s = _s;
                        }
                      }
                    })
                  ]
                },
              ]
            },
          ]
        })

      ]
    })
  );
};
 